export default {"src":"/_next/static/media/googlePayColor.74372bc1.svg","height":435,"width":766,"blurWidth":0,"blurHeight":0};